import { useImmer } from "use-immer";
import { useEffect } from "react";
import DayOfWeekCheckboxes from "../DayOfWeekCheckboxes";
import Multiselect from "../Multiselect";

const Component = ({ config, ruleInfoItems, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <article>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Update on days</td>
            <td>
              <DayOfWeekCheckboxes
                dayOfWeekArray={data.updateAtDays}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtDays = e;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Update on time [CET]</td>
            <td>
              <input
                type="time"
                value={data.updateAtTime}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtTime = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDaysMin}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDaysMin =
                      e.target.value < 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDaysMax}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDaysMax =
                      e.target.value < 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Validation - Total job iterations min.</td>
            <td>
              <input
                type="number"
                value={data.totalIterationsMin}
                step={1000000}
                onChange={(e) =>
                  updateData((d) => {
                    d.totalIterationsMin =
                      e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Validation - True positives min.</td>
            <td>
              <input
                type="number"
                value={data.truePositivesMin}
                step={1}
                onChange={(e) =>
                  updateData((d) => {
                    d.truePositivesMin =
                      e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Use Effective ratio</td>
            <td>
              <input
                type="checkbox"
                checked={data.isUseEffectiveRatio}
                onChange={(e) =>
                  updateData((d) => {
                    d.isUseEffectiveRatio = !d.isUseEffectiveRatio;
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  );
};

export default Component;
